import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Event, Router, NavigationStart, NavigationEnd } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { PlatformLocation } from "@angular/common";
import { AuthenticationService } from "./_services/authentication.service";
import { IdleService } from "./_services/idle.service";
import { GuestService } from "./_services/guest.service";
import { filter } from "rxjs/internal/operators/filter";
import { ConfigurationService } from "./_services/configuration.service";
import { IConfiguration } from "./_models/configuration/IConfiguration";
import { environment } from "src/environments/environment";

declare var gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit {
  currentUrl: string;
  // Protectie temporara testare
  errorMessage: string;
  @ViewChild("password") password: ElementRef;
  allowAccess = false;
  googleAnalyticsID = '';

  constructor(
    public _router: Router,
    location: PlatformLocation,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    private guestService: GuestService,
    private idleService: IdleService,
    private configService: ConfigurationService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        // this.spinner.show();
        // location.onPopState(() => {
        //   window.location.reload();
        // });

        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        // this.spinner.hide();
      }
      window.scrollTo(0, 0);
    });
  }

  ngAfterViewInit() {
    // subscribe to router events and send page views to Google Analytics
    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        gtag('config', this.googleAnalyticsID, {'page_path': event.urlAfterRedirects});
      });
  }

  ngOnInit() {
    // redirectare fortata la https
    if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }

    this.authenticationService.autoLogin();
    this.guestService.autoLogin();

    // pornim monitorizarea idle
    const account = this.authenticationService.getAccount();
    if (account) {
      this.idleService.start();
    }

    // incarcam configurarea pentru google analytics
    this.configService.getPublicConfig('googleAnalyticsID').subscribe(
      (res: IConfiguration) => {
        this.googleAnalyticsID = res.value;
      });
    
    // favicon custom
    if (environment.customInterface) { 
      document.getElementById('appFavicon').setAttribute('href', 'assets/images/favicon-custom.ico');
    }
    
    // daca exista ferestre deschise si extisa in storage newLogin, atunci se va face refresh la pagina
    window.addEventListener('storage', (event) => {
      if (event.key === 'newLogin') {
        location.reload();
      }
    });

    // Protectie temporara pentru testare
    // const lc = localStorage.getItem("test");
    // if (lc) {
    //   const passDecoded = atob(lc);
    //   if (passDecoded === "TestarePortalMedical2020") {
    //     this.allowAccess = true;
    //   }
    // }
  }

  // Protectie temporara pentru testare
  // doAccess() {
  //   const pass = this.password.nativeElement.value;
  //   if (pass === "TestarePortalMedical2020") {
  //     localStorage.setItem("test", btoa(pass));
  //     delete this.errorMessage;
  //     window.location.href = "/";
  //   } else {
  //     this.errorMessage = "Parola este incorecta";
  //   }
  // }
}
